// The Sero product carousel: arrows page through the track, a bar shows how far you are.
// Related products load after the page, so carousels are wired up whenever they appear.
(() => {
  const wire = (carousel) => {
    if (carousel.dataset.ready) return;
    const track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;
    carousel.dataset.ready = 'true';
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const bar = carousel.querySelector('[data-carousel-progress]');

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const visible = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      if (bar) {
        bar.style.width = `${Math.max(visible, 0.08) * 100}%`;
        bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * (1 / Math.max(visible, 0.08) - 1) * 100 : 0}%)`;
      }
      if (prev) prev.disabled = track.scrollLeft <= 8;
      if (next) next.disabled = track.scrollLeft >= max - 8;
      carousel.classList.toggle('sero-carousel--static', max <= 2);
    };
    const page = (direction) => {
      const slide = track.querySelector('.sero-carousel__slide');
      const step = slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      const perPage = Math.max(1, Math.floor((track.clientWidth + 1) / step));
      track.scrollBy({ left: direction * step * perPage, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => page(-1));
    next?.addEventListener('click', () => page(1));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const scan = () => document.querySelectorAll('[data-sero-carousel]').forEach(wire);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
